<app-modal>
    <ng-container class="modal-header" modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </ng-container>
    <ng-container class="modal-body" modal-body>
        <app-activity-form [dropdownItems]="dropdownItems"
                           [showErrors]="showErrors">
        </app-activity-form>
    </ng-container>
    <ng-container class="modal-footer" modal-footer>
        <app-button type="simple"
                    (click)="onCancel()">
            {{ "generic.buttons.close" | translate }}
        </app-button>
        <app-button type="primary" (click)="onConfirm()">
            {{
                'admin.toolMaintenancePlans.activities.save' | translate
            }}
        </app-button>
    </ng-container>
</app-modal>
